import { useCallback, useState } from 'react';

/**
 * Sobreposição de "gerando arquivo" enquanto a exportação roda.
 *
 * A geração do PDF é síncrona e bloqueia a thread. Só ligar o estado antes não
 * basta: o navegador não chega a pintar. Por isso o `await` de um quadro antes
 * de começar — sem ele a sobreposição aparece e some sem nunca ser vista.
 */
export function useExportacao(): {
  exportando: boolean;
  exportar: (tarefa: () => void | Promise<void>) => Promise<void>;
} {
  const [exportando, setExportando] = useState(false);

  const exportar = useCallback(async (tarefa: () => void | Promise<void>) => {
    setExportando(true);

    await new Promise<void>((resolve) => {
      requestAnimationFrame(() => setTimeout(resolve, 0));
    });

    try {
      await tarefa();
    } finally {
      setExportando(false);
    }
  }, []);

  return { exportando, exportar };
}

export default useExportacao;
